import { render, staticRenderFns } from "./InvoicesNotSent.vue?vue&type=template&id=cb150592&scoped=true&"
import script from "./InvoicesNotSent.vue?vue&type=script&lang=js&"
export * from "./InvoicesNotSent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb150592",
  null
  
)

export default component.exports